export enum GalleryCategory {
  productDetail = "productDetail",
  ModelView = "ModelView",
  matchScreenDetail = "matchScreenDetail",
}
